// extracted by mini-css-extract-plugin
module.exports =  {"wrapper":"QQQcFjb","text":"Lg6kqKH"};